import { render, staticRenderFns } from "./reportPaxTotalsNat.vue?vue&type=template&id=7eae2a5a&"
import script from "./reportPaxTotalsNat.vue?vue&type=script&lang=js&"
export * from "./reportPaxTotalsNat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports